"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExponent = exports.getValue = exports.formatPercentage = exports.formatCurrency = exports.formatPlainNumber = exports.formatNumberWithExponent = exports.getOnlyNumbers = void 0;
var LOCALE = 'pt-BR';

var getOnlyNumbers = function getOnlyNumbers(value) {
  var numbers = String(value).replace(/\D+/g, '');
  return Number(numbers);
};

exports.getOnlyNumbers = getOnlyNumbers;

var formatNumberWithExponent = function formatNumberWithExponent(value) {
  var compactDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'short';
  return new Intl.NumberFormat(LOCALE, {
    style: 'decimal',
    notation: 'compact',
    compactDisplay: compactDisplay,
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  }).format(getOnlyNumbers(value));
};

exports.formatNumberWithExponent = formatNumberWithExponent;

var formatPlainNumber = function formatPlainNumber(value) {
  if (!value) {
    return '';
  }

  return new Intl.NumberFormat(LOCALE, {
    style: 'decimal'
  }).format(getOnlyNumbers(value));
};

exports.formatPlainNumber = formatPlainNumber;

var formatCurrency = function formatCurrency(value) {
  var hasExpoent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Intl.NumberFormat(LOCALE, _objectSpread({
    style: 'currency',
    currency: 'BRL'
  }, hasExpoent ? {
    notation: 'compact',
    compactDisplay: 'short'
  } : {})).format(value);
};

exports.formatCurrency = formatCurrency;

var formatPercentage = function formatPercentage(value) {
  return new Intl.NumberFormat(LOCALE, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value / 100);
};

exports.formatPercentage = formatPercentage;

var getValue = function getValue(value) {
  return formatNumberWithExponent(value).split(' ')[0];
};

exports.getValue = getValue;

var getExponent = function getExponent(value) {
  return formatNumberWithExponent(value).split(' ')[1];
};

exports.getExponent = getExponent;